





















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { parseThisMonth, dateTypeItems } from '../render';
import { ITimeParsed, ITimeType } from '../types';
import TooltipIcon from '@/components/widget/TooltipIcon.vue';
import TimeSelect from './TimeSelect.vue';

// 小组件的时间设置选择器
@Component({
  components: { TooltipIcon, TimeSelect },
})
export default class HomeWidgetDatePicker extends Vue {
  @Prop() public period!: ITimeType;  // 初始时间段
  @Prop() public startTime!: string;  // 初始开始时间(仅当时间段为'自定义'时有值)
  @Prop() public endTime!: string;    // 初始结束时间(仅当时间段为'自定义'时有值)
  @Prop({ type: Boolean, default: false }) public disabled!: boolean;

  public visible = false;
  public isInit = false;  // 是否是初始状态

  public pickerStartTime = '';  // 时间选择器的开始时间
  public pickerEndTime = '';    // 时间选择器的结束时间
  
  public selectedShowTime = '';                       // 选中的显示时间
  public selectedPeriod: ITimeType = '';              // 选中的时间段
  public parsedTimeInfo: ITimeParsed | null = null;   // 解析后的时间信息
  public submitedPeriod: ITimeType = '';              // 保存后的时间段
  public submitedTimeInfo: ITimeParsed | null = null; // 保存后的时间信息

  // 获取初始时间信息
  public get initTimeParsed() {
    return this.getTimes(this.period, this.startTime, this.endTime);
  }

  // 赋初始值 
  // emit: change
  @Watch('initTimeParsed', { immediate: true })
  public watchInitTimeParsed(value: ITimeParsed | null) {
    if (value) {
      const period = this.period || 'thismonth';
      this.isInit = true;
      this.updateTimes(value);
      this.updateSubmits(period, value);
      this.$emit('change', period, value);
    }
  }

  // 根据选择的时间段，获取解析后的时间信息
  public get timeParsed() {
    if (this.isIntervalType) {
      return this.getTimes(this.selectedPeriod, this.pickerStartTime, this.pickerEndTime);
    } else {
      return this.getTimes(this.selectedPeriod);
    }
  }

  @Watch('timeParsed', { immediate: true })
  public watchTimeParsed(value: ITimeParsed | null) {
    if (value) {
      this.updateTimes(value);
    }
  }

  // 是否是自定义时间段
  public get isIntervalType() {
    if (this.selectedPeriod === 'interval') {
      if (!this.isInit) {
        // 手动切换到自定义时，默认选择当月
        const currentMonth = parseThisMonth();
        this.updateTimes({ ...currentMonth, shortName: '' });
      }
      this.isInit = false;
      return true;
    } else {
      return false;
    }
  }

  // 提交后的显示时间
  public get submitedTime() {
    const data = this.submitedTimeInfo;
    return data?.shortName || data?.showTime || '';
  }

  // 获取解析后的时间信息
  public getTimes(period: ITimeType, startTime?: string, endTime?: string) {
    const type = period || 'thismonth';
    const start = startTime || '';
    const end = endTime || '';
    const result = dateTypeItems.find((item) => item.value === type);
    return result?.parser?.(start, end) || null;
  }

  // 将解析后的时间信息更新到页面
  public updateTimes(value: ITimeParsed) {
    this.parsedTimeInfo = value;
    this.pickerStartTime = value.startTime || '';
    this.pickerEndTime = value.endTime || '';
    this.selectedShowTime = value.showTime || '';
  }

  // 更新已经提交的时间信息
  public updateSubmits(period: ITimeType, value: ITimeParsed | null) {
    this.selectedPeriod = period;
    this.submitedPeriod = period;
    this.submitedTimeInfo = value;
  }

  // 外部组件使用 $ref 手动调用来触发更新
  // emit: change
  public update() {
    const period = this.selectedPeriod || this.period || 'thismonth';
    const start = this.pickerStartTime || this.startTime || '';
    const end = this.pickerEndTime || this.endTime || '';
    const value = this.getTimes(period, start, end);
    if (value) {
      this.updateTimes(value);
      this.updateSubmits(period, value);
      this.$emit('change', period, value);
    }
  }

  // 保存时间设置
  // emit: change, save
  public onSave() {
    const period = this.selectedPeriod;
    const parsedTime = this.parsedTimeInfo;
    this.visible = false;
    if (period && parsedTime) {
      this.updateSubmits(period, parsedTime);
      this.$emit('change', period, parsedTime);
      this.$emit('save', period, parsedTime);
    }
  }

  // 关闭弹窗时，还原时间设置
  @Watch('visible')
  public watchVisible(visible: boolean) {
    if (!visible) {
      this.selectedPeriod = this.submitedPeriod;
      this.updateTimes(this.submitedTimeInfo!);
    }
  }
}
